import {Action, handleActions} from "redux-actions";
import {BillOfMaterialsState} from "./BillOfMaterialsState";
import {
	BILL_OF_MATERIAL_REMOVED,
	BILL_OF_MATERIALS_FETCHED,
	BILLS_OF_MATERIALS_FETCHED
} from "../../action/billOfMaterials/actionType";

/**
 * Initial state for jobs.
 */
const initState: BillOfMaterialsState = {
	bomMap: {},
	bomPreviewMap: {}
};

const reducer = handleActions({
	[BILL_OF_MATERIALS_FETCHED]: (state: BillOfMaterialsState,
		action: Action<any>): BillOfMaterialsState => {
		return {
			...state,
			bomMap: {
				...state.bomMap,
				[action.payload.jobId]: action.payload.bom,
			}
		}
	},
	[BILL_OF_MATERIAL_REMOVED]: (state: BillOfMaterialsState,
		action: Action<BILL_OF_MATERIAL_REMOVED>): BillOfMaterialsState => {
		return {
			...state,
			bomMap: {
				...state.bomMap,
				[action.payload.jobId]: null,
			}
		}
	},
	[BILLS_OF_MATERIALS_FETCHED]: (state: BillOfMaterialsState,
		action: Action<BILLS_OF_MATERIALS_FETCHED>): BillOfMaterialsState => {
		return {
			...state,
			bomPreviewMap: {
				...state.bomPreviewMap,
				[action.payload.jobId]: action.payload.boms,
			}
		}
	},

}, initState);

export default reducer;